import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'

// Combined screen for when both affirmPrimary and affirmBackup are due at
// once — one "yes, they are" affirms both addresses in a single action
// instead of two sequential lightweight asks.
const EmailVerificationAffirmBothOffer = (props) => {
  const {
    primaryEmail, backupEmail, onAffirm, onRemindLater, onUpdateEmails,
    remindLoading, confirmLoading, confirmedMessage, errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration checkColor={confirmedMessage ? '#30C99C' : undefined} />
      <div className='emailVerificationFlow-title'>Are these still your emails?</div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Account email</div>
        <div className='emailVerificationFlow-emailDisplay'>{primaryEmail}</div>
        <div className='emailVerificationFlow-emailBox-label emailVerificationFlow-emailBox-label--spaced'>
          Backup email
        </div>
        <div className='emailVerificationFlow-emailDisplay'>{backupEmail}</div>
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      {confirmedMessage && (
        <div className='emailVerificationFlow-codeEntry-verifiedMessage'>{confirmedMessage}</div>
      )}
      <button
        type='button'
        className={`btn btn--blue btn--large${(confirmLoading || confirmedMessage) ? ' btn--disabled' : ''}`}
        onClick={onAffirm}
        disabled={confirmLoading || !!confirmedMessage}
      >
        Yes, they are
      </button>
      {!confirmedMessage && (
        <div className='emailVerificationFlow-primaryOffer-links'>
          <button type='button' className='emailVerificationFlow-linkBtn' onClick={onUpdateEmails}>
            Update emails
          </button>
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onRemindLater}
            disabled={remindLoading}
          >
            Remind me later
          </button>
        </div>
      )}
    </div>
  )
}

export default EmailVerificationAffirmBothOffer
